<sm-screen-load [loading]="false" [failed]="false"></sm-screen-load>
<main class="ssr-demo">
  <p class="ssr-demo__eyebrow">SSR demo route</p>
  <h1 class="ssr-demo__title">Angular Universal is serving this route</h1>
  <p class="ssr-demo__body">
    This page is rendered on the server so the container has a simple, reliable SSR target.
  </p>
</main>
